export class UserScrapAgentStorage {
  static readonly featureIdx = 5;
  totalStorage: string;
  usagePercent: string;
  totalUsed: string;

  constructor() {
    this.totalStorage = '0GB';
    this.usagePercent = '0';
    this.totalStorage = '0GB';
  }
}
